import { memo, useEffect, useState } from "react";
import OrganizationItem from "./OrganizationItem";
import { Organization_Base } from "~/common/typescript/models/Organization";
import { AC_Organization_Role } from "~/common/typescript/services/access_control/AC_Organization";
import { OrganizationAPIs } from "~/common/typescript/apis/OrganizationAPIs";
import { Button, Modal } from "antd";
import FormCreateOrganization from "./FormCreateOrganization";
import { LuPlus } from "react-icons/lu";
import styled from "styled-components";

const ListMyOrg = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [organizations, setOrganizations] = useState<Organization_Base[]>([]);
  const fetchData = () => {
    OrganizationAPIs.remote_getMyOrg().then((organizations) => {
      setOrganizations(organizations || []);
    });
  }

  const onClickCreateOrg = () => {
    setIsModalOpen(true);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <UI_Wrapper>
      <UI_Header>
        <UI_TitleRow>
          <UI_Title>Doanh nghiệp bạn quản lý</UI_Title>
          {organizations?.length > 0 && <UI_Badge>{organizations.length}</UI_Badge>}
        </UI_TitleRow>
        <Button
          type="primary"
          icon={<LuPlus />}
          onClick={onClickCreateOrg}
          size="middle"
        >
          Tạo mới
        </Button>
      </UI_Header>

      <Modal
        title="Tạo mới doanh nghiệp"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        footer={null}
        onCancel={() => setIsModalOpen(false)}
        onClose={() => setIsModalOpen(false)}
      >
        <FormCreateOrganization callbackSuccess={() => { setIsModalOpen(false); fetchData() }} />
      </Modal>

      <UI_List>
        {organizations?.map((organization) => (
          <OrganizationItem key={organization.id} organization={organization} role={AC_Organization_Role.ORGANIZATION_OWNER} />
        ))}
      </UI_List>
    </UI_Wrapper>
  );
};

export default memo(ListMyOrg);

const UI_Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #f1f5f9;
`;

const UI_Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const UI_TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const UI_Title = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

const UI_Badge = styled.span`
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const UI_List = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 10px;
`